export const shouldUseBetaCheckout = (searchString) => {
  const params = new URLSearchParams(searchString)
  const useBetaCheckout = params.get('useBetaCheckout')
  return useBetaCheckout ? useBetaCheckout.toLowerCase() === 'true' : false
}
